import { ObservationReferenceRange } from '@medplum/fhirtypes'

export const getResultThresholds = (
    referenceRange?: ObservationReferenceRange
): [number, number] | null => {
    if (!referenceRange?.low?.value || !referenceRange?.high?.value) {
        return null
    }

    return [referenceRange.low.value, referenceRange.high.value]
}
